import _ from 'lodash';


export const operatorDescriptions = {
  eq: 'equal to',
  le: 'less than or equal to',
  lt: 'less than',
  ge: 'greater than or equal to',
  gt: 'greater than',
  ne: 'not equal to',
  in: 'one of the following',
  '!in': 'not in one of the following',
  ixn: 'containing one of the following',
  '!ixn': 'not containing one of the following',
};

export const getOperatorDescription = operator => {
  return operatorDescriptions[operator] || operator;
};
/**
 * Get segment name from combined value
 * @param {string} combinedValue the value might be literally combined by namespace, segment name.
 * @returns {string}
 */
export const getSegmentName = combinedValue => {
  if (!combinedValue) return '';

  const splits = combinedValue.split('.');
  return splits.length <= 1
    ? combinedValue
    : (() => {
      splits.splice(0, 1);
      return splits.join('.');
    })();
};

// getSegmentNamespace returns the nemespace embedded in the combined segment name
export const getSegmentNamespace = combinedValue => {
  if (!combinedValue || !_.includes(combinedValue, '.')) {
    return 'shared';
  }
  const splits = combinedValue.split('.');
  return splits[0];
};

/**
 * get preferred back-end combined value
 * @param {{segmentName: string, namespace: string}} segment segment object
 * @returns {string}
 */
export const getCombinedSegmentValue = segment => {
  if (!segment || !segment.segmentName) return '';

  return segment.namespace
    ? `${segment.namespace}.${segment.segmentName}`
    : segment.segmentName;
};

export const getTaxiName = (countries, countryID, taxiTypeID) => {
  const country = _.find(countries, ['countryID', countryID]);
  if (country) {
    for (const city of country.cities) {
      const taxiType = _.find(city.taxiTypes, ['taxiTypeID', taxiTypeID]);
      if (taxiType) {
        return taxiType.name;
      }
    }
  }
  return taxiTypeID; // return taxiTypeID if the name is not found
};

export const getCityName = (countries, countryID, cityID) => {
  const country = _.find(countries, ['countryID', countryID]);
  if (country) {
    const city = _.find(country.cities, ['cityID', cityID]);
    if (city) {
      return city.name;
    }
  }
  return cityID; // return cityID if the name is not found
};

// 'eventObjects' is object from listRuleTypes endpoints.
// e.g: [ {"eventType": "onRideDroppingOff", "ruleTypes": [{"variableName": "var.ride.pickupCityID", "noun": "Pickup City ID"}] }]
export const getConditionName = (eventObjects, variableName) => {
  for (const eventObject of eventObjects) {
    const ruleType = _.find(eventObject.ruleTypes, ['variableName', variableName]);
    if (ruleType) {
      return ruleType.noun;
    }
  }
  // If no match is found, return original variableName
  return variableName;
};

export const getConditionDropdownList = (eventObjects, variableName) => {
  for (const eventObject of eventObjects) {
    const ruleType = _.find(eventObject.ruleTypes, ['variableName', variableName]);
    if (ruleType) {
      return _.get(ruleType, 'options', {}); // Map of object. Key : Value, Value : Label
    }
  }
  return {};
};

// used to test purpose only. When we to test locally.
export const mockScenarioSearchHistoryModel = [
  {
    ruleEvalRecord: {
      timestamp: '2023-02-05T23:58:17.985742644+08:00',
      accountType: 'passenger',
      accountID: '175562329',
      trackingKey: 'ride_A-4HM7JU8WWH76_COMPLETED',
      treatmentID: 516548,
      campaignName: '',
      campaignLink: '',
      failedCondition: {
        Operator: 'in',
        Variable: 'var.ride.pickupCityID',
        Expected: '[20 35 43 44 62 66 69 75 76 81 84 34 28 40]',
        Actual: '18',
      },
      errMessage: '',
    },
  },
  {
    ruleEvalRecord: {
      timestamp: '2023-02-05T23:58:18.466724372+08:00',
      accountType: 'passenger',
      accountID: '145530942',
      trackingKey: 'ride_A-4HM7TB2WWER6_COMPLETED',
      treatmentID: 516548,
      campaignName: '',
      campaignLink: '',
      failedCondition: {
        Operator: 'ixn',
        Variable: 'var.passenger.segment',
        Expected: '[shared.ID22WEST-BLM-TG1_2023-January-2]',
        Actual: '[shared.ID22WEST-BLM-TG3_2023-January-2]',
      },
      errMessage: '',
    },
  },
  {
    ruleEvalRecord: {
      timestamp: '2023-02-05T23:58:21.925575522+08:00',
      accountType: 'passenger',
      accountID: '277081637',
      trackingKey: 'ride_A-4HM7NV4WWHR9_COMPLETED',
      treatmentID: 516548,
      campaignName: '',
      campaignLink: '',
      failedCondition: {
        Operator: 'in',
        Variable: 'var.ride.serviceID',
        Expected: '[434 3655 3841 332 8094]',
        Actual: '358',
      },
      errMessage: '',
    },
  },
  {
    ruleEvalRecord: {
      timestamp: '2023-02-05T23:58:26.766774857+08:00',
      accountType: 'passenger',
      accountID: '4176256',
      trackingKey: 'ride_A-4HM9GU6GWFB5_COMPLETED',
      treatmentID: 516548,
      campaignName: '',
      campaignLink: '',
      failedCondition: {
        Operator: 'eq',
        Variable: 'var.ride.profile',
        Expected: 'BP',
        Actual: 'GFB',
      },
      errMessage: '',
    },
  },
  {
    ruleEvalRecord: {
      timestamp: '2023-02-05T23:58:31.237599224+08:00',
      accountType: 'passenger',
      accountID: '63577392',
      trackingKey: 'ride_A-4HM9XDVWWJB6_COMPLETED',
      treatmentID: 516548,
      campaignName: '',
      campaignLink: '',
      failedCondition: {
        Operator: 'in',
        Variable: 'var.ride.pickupCityID',
        Expected: '[20 35 43 44 62 66 69 75 76 81 84 130 132 146 218 219 225 231 34 28 40 337]',
      },
      errMessage: 'Unable to get city ID',
    },
  },
  {
    ruleEvalRecord: {
      timestamp: '2023-02-05T23:58:31.237599224+08:00',
      accountType: 'passenger',
      accountID: '63577392',
      trackingKey: 'ride_A-4HM9XDVWWJB6_COMPLETED',
      treatmentID: 516568,
      campaignName: '',
      campaignLink: '',
      failedCondition: {
        Operator: 'in',
        Variable: 'var.ride.pickupCityID',
        Expected: '[20 35 43 44 62 66 69 75 76 81 84 130 132 146 218 219 225 231 34 28 40 337]',
        Actual: '10',
      },
      errMessage: '',
    },
  },
];
